import { render, staticRenderFns } from "./smsVerification.vue?vue&type=template&id=2846a1d9&scoped=true&"
import script from "./smsVerification.vue?vue&type=script&lang=js&"
export * from "./smsVerification.vue?vue&type=script&lang=js&"
import style0 from "./smsVerification.vue?vue&type=style&index=0&id=2846a1d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846a1d9",
  null
  
)

export default component.exports